























import Vue from 'vue';
import $ from 'jquery';
import _ from 'lodash';

// TODO TEMP until we figure out how to go about this
// eslint-disable-next-line no-restricted-imports
import initLibs from 'legacy/_general/init_libs';

import { ModalSize } from '@/components/zen_modal/types';

import LoadingState from './loading_state/LoadingState.vue';

export default Vue.extend({
  name: 'ObjectInfo',
  components: { LoadingState },
  props: {
    type: {
      type: String,
      required: true,
    },
    id: {
      type: [Number, String],
      required: true,
    },
    config: {
      type: Object,
      default: () => {
        return {
          link: '',
        };
      },
    },
  },
  data() {
    return {
      htmlContent: <string>'',
      lastLocation: <string>this.config.link,
      isLoading: <boolean>true,
      errorLoading: <boolean>false,
      detailedView: <boolean>this.viewState(),
    };
  },
  created() {
    this.$emit('updateConfig', { size: ModalSize.Large });
    this.handleObjectType(this.type);

    const url = this.config.link || `/sor/info/${this.type}/${this.id}/info`;
    this.fetchPage(url);

    Vue.nextTick().then(() => {
      // Fetch fake form submits
      $(this.$el).on('reload', (ev, link) => {
        this.fetchPage(link);
      });

      // Fetch table filter form submits
      $(this.$el).on('submit', '.header-filter form', ev => {
        ev.preventDefault();

        let targetUrl = this.lastLocation;
        const activeTab = $(this.$el).find('.mapped-object-types .active');

        if (activeTab.length) {
          targetUrl = activeTab[0].href;
        }

        // Find submit type
        let submitType = 'filter';
        if (document.activeElement.type === 'submit') {
          submitType = document.activeElement.name;
        }

        const form = $(ev.currentTarget);
        const formData = this.extractFormData(form);
        const requestData = {
          'filter-field': formData.filter_field,
          'filter-operator': formData.filter_operator,
          'filter-value': formData.filter_value,
          [submitType]: '',
        };

        $.ajax({
          url: targetUrl,
          method: 'POST',
          headers: { 'X-CSRF-Token': formData.csrf_token },
          data: requestData,
          success: data => {
            this.htmlContent = $(data)
              .find('.object-info')
              .html();

            this.$nextTick().then(initLibs);
          },
        });
      });

      // Fetch link clicks
      $(this.$el).on('click', 'a.js-persist-modal', ev => {
        const clickedLink = <HTMLAnchorElement>ev.currentTarget;
        if (clickedLink.classList.contains('nav-link') && (clickedLink.textContent as string).trim() === 'Comments') {
          // We opened the comments tab, so the page should be refreshed later.
          window.GGRC.zenModal.$emit('reloadPage');
        }
        ev.preventDefault();
        this.fetchPage(clickedLink.href);
      });

      // Fetch edit link clicks
      $(this.$el).on('click', '.inline-edit-link:not([data-prevent-modal])', ev => {
        const dataset = ev.currentTarget.dataset;

        GGRC.zenModal.show({
          type: 'EditCard',
          data: {
            ids: [Number(dataset.identifier)],
            type: dataset.objectType,
            field: dataset.attrSlug,
          },
        });
      });

      // Toggle simple view
      $(this.$el).on('click', '.js-toggle-view', () => {
        this.detailedView = !this.detailedView;
        this.viewState(this.detailedView);
        this.fetchPage(this.lastLocation);
      });

      // Map/Unmap link hook
      $(this.$el).on(
        'click',
        `.edit-mapped-objects,
         .inline-edit-link[href*="object_mapper"],
         .add-mapped-object`,
        ev => {
          ev.preventDefault();
          const redirectUrl = location.pathname + location.search;
          const url = new URL(ev.currentTarget.href);
          url.searchParams.set('redirect_url', redirectUrl);
          url.searchParams.set('back_url', redirectUrl);
          location.href = url.href;
        }
      );

      GGRC.zenModal.$on('reload', () => {
        this.fetchPage(this.lastLocation);
        window.GGRC.zenModal.$emit('reloadPage');
      });
    });
  },
  methods: {
    fetchPage(link: string) {
      this.isLoading = true;
      this.errorLoading = false;
      // Store last link
      this.lastLocation = link;
      link = this.formatCardUrl(link);
      $.get(link)
        .done(data => {
          this.$emit('updateConfig', { link });
          this.htmlContent = $(data)
            .find('.object-info')
            .html();
          this.isLoading = false;
          this.$nextTick().then(initLibs);
        })
        .fail(() => {
          this.errorLoading = true;
          this.isLoading = false;
        });
    },
    extractFormData(form: JQuery<HTMLFormElement>) {
      return _(form.serializeArray())
        .filter(data => !!data.value)
        .keyBy('name')
        .mapKeys((value, key) => _.snakeCase(key))
        .mapValues('value')
        .value();
    },
    formatCardUrl(link: string): string {
      const url = new URL(link, location.origin);
      const simpleTabs = ['attachments', 'comments'];
      const splitUrl = url.pathname.split('/');

      if (!this.detailedView && !simpleTabs.includes(splitUrl[5])) {
        splitUrl[splitUrl.length - 1] = simpleTabs[0];
      }

      url.searchParams.set('card', 'true');

      if (this.detailedView) {
        url.searchParams.delete('simple_view');
      } else {
        url.searchParams.set('simple_view', 'true');
      }

      return splitUrl.join('/') + url.search;
    },
    viewState(state: boolean) {
      const key = 'cardViewState';
      if (arguments.length) {
        localStorage.setItem(key, String(state));
      } else {
        return localStorage.getItem(key) === 'true';
      }
      return false;
    },
    handleObjectType(objectType: string): void {
      switch (objectType) {
        case 'ExternalRequest': {
          this.detailedView = true;
          this.viewState(this.detailedView);
          break;
        }
      }
    },
  },
});
